{{#if hasSchemas}}
<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Gateway Dashboard"}}</h4>
	</div>
</div>
<div class="row">
{{#each schema}}
	<div id="js-container-{{@index}}" class="col-xs-12 col-sm-6 col-md-3">
		<div class="card-box clearfix js-miniatur-scheme">
			<div class="js-schema-notfound-{{@index}}" style="height:150px;">
				<p>{{TR "Leider gibt es für diesen Anlagentyp momentan keine graphische Darstellung."}} </p>
			</div>
			<a id="js-schema-link-{{@index}}" href="#controller/{{this.id}}/status-schema">
				<div id="schema-container-{{@index}}" style="height: 150px;">
					<object id="schema-svg-{{@index}}" type="image/svg+xml"></object>
				</div>
				<div class="m-b-0 pull-left">
					{{{COLUMN_DATA this "#_plain_name" undefined}}}<br>
				</div>
			</a>
			<div id="js-info-link-{{@index}}" class="m-b-0 pull-left">
				{{{COLUMN_DATA this "#_plain_name" undefined}}}<br>
			</div>
		</div>
	</div>
{{/each}}
</div>
{{else}}
<div class="row">
	<div class="col-xs-12">
		<div class="card-box clearfix">
			<h3>{{TR "Keine Geräte gefunden"}}</h3>
			<p>{{TR "Es wurden keine angeschlossenen Geräte gefunden."}}</p>
		</div>
	</div>
</div>
{{/if}}
